import EmailModal from './EmailModal'

export default EmailModal